import { gql } from '@apollo/client'

const SEARCH_INSURANCE_POLICIES = gql`
  query SEARCH_INSURANCE_POLICIES($searchTerm: String!, $insuranceCompany: ID) {
    searchInsurancePolicies(searchTerm: $searchTerm, insuranceCompany: $insuranceCompany) {
      id
      policyNumber
      holderName
      coverageType
      relationship
      status
      due
      inception
      priceList {
        id
        name
      }
    }
  }
`

export default SEARCH_INSURANCE_POLICIES
